import { get } from 'lodash';

const parseContent = (content = '', dictionary = {}) => {
  const re = new RegExp(/{{.*?}}/gi); // NOSONAR
  return content.replace(re, message => {
    const path = message.slice(2, message.length - 2);
    return get(dictionary, path, '');
  });
};

export default parseContent;
